import { render, staticRenderFns } from "./RecentInterviewCard.vue?vue&type=template&id=45146b15"
import script from "./RecentInterviewCard.vue?vue&type=script&lang=js"
export * from "./RecentInterviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports